<template>
    <div>
        <p class="bigTitle"><span class="floor">*</span>商品管理>房态管理</p>
        <div class="body">
            <div class="left">
                <p class="leftP"><i class="el-icon-share"></i>全部100</p>
                <p class="leftP"><i class="el-icon-info"></i>空净50</p>
                <p class="leftP"><i class="el-icon-picture"></i>空脏2</p>
                <p class="leftP"><i class="el-icon-s-cooperation"></i>住净30</p>
                <p class="leftP"><i class="el-icon-s-home"></i>住脏10</p>
                <p class="leftP"><i class="el-icon-s-flag"></i>预净25</p>
                <p class="leftP"><i class="el-icon-s-open"></i>预脏15</p>
                <p class="leftP"><i class="el-icon-s-operation"></i>维修房8</p>
            </div>
            <div class="centen">
                <div class="centenStop">
                    <span class="stopFloot">楼层:</span>
                    <el-select v-model="value" clearable placeholder="请选择" class="selectA">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span>房型:</span>
                    <el-select v-model="value" clearable placeholder="请选择" class="selectA">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span>房间号:</span>
                    <el-select v-model="value" clearable placeholder="请选择" class="selectA">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                     <el-button type="primary">搜索</el-button>
                </div>
                <div class="centenBelow">

                    <div class="big">
                        <p class="bigP"><span class="floor">*</span>1楼</p>
                        <div class="roomA">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="roomC">
                        </div>
                        <br/>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="roomC">
                        </div>
                    </div>
                    
                    <div class="big">
                        <p class="bigP"><span class="floor">*</span>2楼</p>
                        <div class="roomA">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="room">
                            <p>1001-豪华大床房</p>
                            <p>空净</p>
                        </div>
                        <div class="roomC">
                        </div>
                    </div>

                </div>
            </div>
            <div class="right">
                <p>1001</p>
                <p>豪华大床房</p>

                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="预   订   人:">
                        <el-input v-model="form.name" class="formInput"></el-input>
                    </el-form-item>
                    <el-form-item label="电话:">
                        <el-input v-model="form.name"  class="formInput"></el-input>
                    </el-form-item>
                    <el-form-item label="入住日期:">
                        <el-input v-model="form.name"  class="formInput"></el-input>
                    </el-form-item>
                    <el-form-item label="离店日期:">
                        <el-input v-model="form.name"  class="formInput"></el-input>
                    </el-form-item>
                    <el-form-item label="入住天数:">
                        <el-input v-model="form.name"  class="formInput"></el-input>
                    </el-form-item>
                    <el-form-item label="房费:">
                        <el-input v-model="form.name"  class="formInput"></el-input>
                    </el-form-item>
                </el-form>
                 <el-button type="primary" class="formButton">办理入住</el-button><br/>
                  <el-button type="primary" class="formButton">办理退房</el-button><br/>
                   <el-button type="primary" class="formButtonEnd">置为脏房</el-button><br/>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    data() {
      return {
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: '',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }

      }
    }
}
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.left{
    background-color:#FFFFFF;
    float: left;
    width: 10%;
    border-radius: 10px;
}

.leftP{
    margin-top: 20%;
}

.centen{
    float: left;
    width: 66%;
    margin-left: 2%;
}

.centenStop{
    background-color:#FFFFFF;
    border-radius: 10px;
}

.selectA{
    margin-right: 5%;
    margin-top: 1%;
    margin-bottom: 1%;
}

.big{
    background-color:#FFFFFF;
    margin-top: 2%;
    border-radius: 10px;
}

.bigP{
    text-align: left;
    margin-left: 2%;
    padding-top: 1%;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.roomA{
    width: 150px;
    height: 150px;
    background-color: #FFFFFF;
    float: left;
    margin-left: 5%;
    border:1px solid #CCCCCC;
    border-radius: 10px;
}

.room{
    width: 150px;
    height: 150px;
    background-color: #FFFFFF;
    margin-left: 5%;
    float: left;
    border:1px solid #CCCCCC;
    border-radius: 10px;
}

.roomC{
    clear:both;
    margin-bottom: 1%;
}

.right{
    background-color: #FFFFFF;
    float: left;
    width: 20%;
    margin-left: 2%;
    border-radius: 10px;
}

.formInput{
    width: 80%; 
}

.formButton{
    margin-top: 5%;
    width: 70%;
}

.formButtonEnd{
     margin-top: 5%;
     width: 70%; 
     margin-bottom: 10%;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/houseState/houseState.vue